// This file was generated using `pay js:run gql-v1 --type=fragment --name=StripeAccountRequirements --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';

import type {
  Exact,
  OpenapiAccountRequirementsDisabledReasonEnum,
} from '@stripe-internal/data-v1/schema/types';

import type {V1PermissionToken} from '@stripe-internal/data-v1/types';

const doc = gql`
  fragment StripeAccountRequirementsFragment on OpenapiAccountRequirements {
    current_deadline
    currently_due
    disabled_reason
    past_due
  }
`;

export const stripeAccountRequirementsFragment: StripeAccountRequirementsFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type StripeAccountRequirementsFragmentData = {
  readonly __typename: 'OpenapiAccountRequirements';
  readonly current_deadline: number | null;
  readonly currently_due: ReadonlyArray<string> | null;
  readonly disabled_reason: OpenapiAccountRequirementsDisabledReasonEnum | null;
  readonly past_due: ReadonlyArray<string> | null;
};

export type StripeAccountRequirementsFragmentVariables = Exact<{
  [key: string]: never;
}>;

const stripeAccountRequirementsFragmentPermissions = {} as const;

doc.permissions = stripeAccountRequirementsFragmentPermissions;

export type StripeAccountRequirementsFragmentPermissions = V1PermissionToken<
  typeof stripeAccountRequirementsFragmentPermissions
>;

export type StripeAccountRequirementsFragmentDocument = GraphQlDocument<
  StripeAccountRequirementsFragmentData,
  StripeAccountRequirementsFragmentVariables,
  StripeAccountRequirementsFragmentPermissions
>;
